import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30" className={className}>
    <mask
      id="mask0_11292_3442"
      style={{ maskType: 'alpha' }}
      width="30"
      height="30"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H30V30H0z"></path>
    </mask>
    <g mask="url(#mask0_11292_3442)">
      <path fill="#000" d="M15 19.219l-7.5-7.5 1.75-1.75 5.75 5.75 5.75-5.75 1.75 1.75-7.5 7.5z"></path>
    </g>
  </svg>
);

export default Icon;
